import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OurAuthService } from 'app/core/auth/auth.service';
import { map } from 'rxjs';

/**
 * Root route (`/`) landing decision.
 *
 * A signed-out visitor gets the public marketing site (`/home`). A visitor who already has a
 * valid session gets their workspace (`getDefaultAuthenticatedLandingUrl()`) instead of being
 * dropped on the sales pitch every time they open the app (PRODUCT-FINDING-016).
 *
 * `check()` resolves a stored-but-not-yet-active token via `signInUsingToken()`, so `userRole`
 * is populated by the time `getDefaultAuthenticatedLandingUrl()` reads it.
 */
export const rootLandingRedirectGuard: CanActivateFn = () => {
    const router = inject(Router);
    const auth = inject(OurAuthService);

    return auth
        .check()
        .pipe(
            map(authenticated =>
                router.parseUrl(authenticated ? auth.getDefaultAuthenticatedLandingUrl() : 'home'),
            ),
        );
};
